import { memo } from "react";

export const Error404Page = memo(() => {
  return (
    <p>404ページです</p>
  );
});